export default __webpack_public_path__ + "5ab27085314ad4ba5e9df2ce5599028a.png";